<template>
  <div class="flex-col page">
    <div class="self-end group">
      <span class="font text">首页 > 组织机构 ></span>
      <span class="font text_2">规则型号查询</span>
    </div>
    <div class="self-stretch section"></div>
    <div class="flex-col self-stretch section_2">
      <div class="flex-row">
        <div class="flex-row items-baseline">
          <span class="font_2 text_3">规格型号</span>
          <span class="font_3 ml-21">ATS-100 R2.0.X</span>
        </div>
        <div class="flex-row items-baseline group_2">
          <span class="font_2 text_4">单元名称</span>
          <span class="font_4 ml-21">ATS子系统</span>
        </div>
        <div class="flex-row items-baseline group_3">
          <span class="font_2 text_5">生产者（制造商）</span>
          <span class="font_4 ml-5">中国国电集团公司</span>
        </div>
      </div>
      <div class="mt-34 flex-row">
        <div class="flex-row items-baseline">
          <span class="font_2 text_6">认证机构</span>
          <span class="ml-22 font_4">国家电网有限公司</span>
        </div>
        <div class="flex-row items-baseline ml-173">
          <span class="font_2 text_7">认证证书号</span>
          <span class="font_3 ml-21">CURC-SRCC-20-XH010201-101</span>
        </div>
      </div>
    </div>
    <span class="self-start font_5 text_8">采信信息</span>
    <div class="flex-col self-stretch group_4 view">
      <div class="flex-row justify-evenly">
        <div class="flex-col justify-start items-start text-wrapper"><span class="font_6 text_9">采信单位</span></div>
        <div class="flex-col justify-start items-start text-wrapper_2">
          <span class="font_6 text_10">国电电力发展股份有限公司</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper"><span class="font_6 text_11">供应商</span></div>
        <div class="flex-col justify-start items-start text-wrapper_2">
          <span class="font_6 text_12">中国国电集团公司</span>
        </div>
      </div>
      <div class="flex-col justify-start items-start relative group_5">
        <div class="flex-col justify-start items-start text-wrapper_5">
          <span class="font_6 text_24">交货日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_13">
          <span class="font_7 text_20">2023-11-26</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_9">
          <span class="font_6 text_21">预计启用日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_10">
          <span class="font_7 text_20">2024-03-20</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_5 pos_5">
          <span class="font_6 text_17">应用数量（个/套/列）</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_6 pos_6"><span class="font_6 text_18">/</span></div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos">
          <span class="font_6 text_13">应用项目</span>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_4 pos_2">
          <span class="font_6 text_14">国电建投察哈素煤矿联合试生产</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_14">
          <span class="font_6 text_25">运营状态</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_6 pos_15">
          <span class="font_6 text_26">查看</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_11">
          <span class="font_6 text_22">产品正式启用日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_8 pos_12">
          <span class="font_8 text_23">-</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_7">
          <span class="font_6 text_19">合同签署日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_8">
          <span class="font_7 text_20">2023-06-16</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_3">
          <span class="font_6 text_15">项目应用列数（列）</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_4 pos_4"><span class="font_6 text_16">/</span></div>
      </div>
    </div>
    <span class="self-start font_5 text_27">获证信息</span>
    <div class="flex-col self-stretch group_4 view_2">
      <div class="flex-col justify-start items-start relative group_6">
        <div class="flex-col justify-start items-start text-wrapper_3">
          <span class="font_6 text_30 text_9">生产者（制造商）名称</span>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_4 pos_20">
          <span class="font_6 text_31">国电建投察哈素煤矿联合试生产</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_5 pos_16">
          <span class="font_6 text_11">认证委托人名称</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_6 pos_17">
          <span class="font_6 text_12">国电电力发展股份有限公司</span>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_3 pos_21">
          <span class="font_6 text_32">生产者（制造商）注册地址</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_4 pos_22">
          <span class="font_6 text_33">/</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_5 pos_18">
          <span class="font_6 text_28">认证委托人地址</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_6 pos_19">
          <span class="font_6 text_29">中国国电集团公司</span>
        </div>
      </div>
      <div class="flex-row justify-evenly">
        <div class="flex-col justify-start items-start text-wrapper_9">
          <span class="font_6 text_24 text_34">生产企业名称</span>
        </div>
        <div class="flex-col justify-start section_3">
          <div class="group_7">
            <span class="font_9">
              1.上海富欣智能交通控制有限公司；2.上海
              <br />
            </span>
            <span class="font_9">
              复珊精密制造有限公司；3.江阴信邦电子有
              <br />
            </span>
            <span class="font_9">限公司</span>
          </div>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_9">
          <span class="font_6 text_21">生产企业实际地址</span>
        </div>
        <div class="flex-col justify-start section_4">
          <div class="group_8">
            <span class="font_9">
              1.中国（上海）自由贸易试验区亮秀路112
              <br />
            </span>
            <span class="font_9">
              号2号楼4层；2.上海市嘉定区银龙路258号
              <br />
            </span>
            <span class="font_9">16幢</span>
          </div>
        </div>
      </div>
      <div class="flex-col justify-start items-start relative group_9">
        <div class="flex-col justify-start items-start text-wrapper_5">
          <span class="font_6 text_39">证书状态</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_6 pos_31">
          <span class="font_6 text_40">有效</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_27">
          <span class="font_6 text_37">证书发证日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_28">
          <span class="font_7 text_20">2023-11-26</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_5 pos_23">
          <span class="font_6 text_35">认证模式</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_24">
          <span class="font_7 text_20">2024-03-20</span>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_5 pos_32">
          <span class="font_6">认证依据的标准和技术要求</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_8 pos_33">
          <span class="font_8 text_41">—</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_29">
          <span class="font_6 text_38">证书到期日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_30">
          <span class="font_7 text_20">2023-06-16</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_5 pos_25">
          <span class="font_6 text_36">首次获证日期</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_7 pos_26">
          <span class="font_7 text_20">2023-06-16</span>
        </div>
      </div>
      <div class="flex-col justify-start items-start relative group_6">
        <div class="flex-col justify-start items-start text-wrapper_3">
          <span class="font_6 text_30 text_45">其他需要标注的信息</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_10 pos_38">
          <span class="font_8 text_46">—</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_36">
          <span class="font_6 text_43">安全完整性等级</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_3 pos_34">
          <span class="font_6 text_42">软件版本</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_8 pos_35">
          <span class="font_8 text_44">—</span>
        </div>
        <div class="flex-col justify-start items-start text-wrapper_4 pos_37">
          <span class="font_6 text_33">T/CAMET 040018.3-2019</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {}
  },

  methods: {}
}
</script>

<style scoped lang="less">
  .ml-21 {
    margin-left: 21px;
  }
  .ml-5 {
    margin-left: 5px;
  }
  .ml-173 {
    margin-left: 173px;
  }
  .page {
    position: relative;
    background-color: #ffffff;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      margin-right: 24px;
      line-height: 14px;
      .font {
        font-size: 14px;
        font-family: PingFang;
        line-height: 14px;
        font-weight: 700;
      }
      .text {
        color: #cccccc;
      }
      .text_2 {
        color: #666666;
      }
    }
    .section {
      margin-right: 6px;
      margin-top: 21px;
      background-color: #e6e6e6;
      height: 1px;
    }
    .section_2 {
      margin: 32px 84px 0 80px;
      padding: 32px 36px;
      background-color: #004290;
      .font_2 {
        font-size: 16px;
        font-family: PingFang;
        line-height: 14px;
        color: #ffffff;
      }
      .text_3 {
        line-height: 15px;
      }
      .font_3 {
        font-size: 12px;
        font-family: PingFang;
        line-height: 10px;
        color: #ffffff;
      }
      .group_2 {
        margin-left: 192px;
        .text_4 {
          line-height: 15px;
        }
      }
      .group_3 {
        margin-left: 207px;
        .text_5 {
          line-height: 15px;
        }
      }
      .font_4 {
        font-size: 12px;
        font-family: PingFang;
        line-height: 12px;
        color: #ffffff;
      }
      .text_6 {
        line-height: 15px;
      }
      .text_7 {
        line-height: 15px;
      }
    }
    .font_5 {
      font-size: 22px;
      font-family: PingFang;
      line-height: 22px;
      color: #333333;
    }
    .text_8 {
      margin-left: 89px;
      margin-top: 33px;
    }
    .group_4 {
      padding-left: 80px;
      padding-right: 76px;
      .text-wrapper {
        padding: 16px 0;
        background-color: #e8f0fa;
        width: 287px;
        height: 52px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
      }
      .text-wrapper_2 {
        padding: 16px 0;
        background-color: #ffffff;
        width: 360px;
        height: 52px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_10 {
          margin-left: 14px;
        }
      }
      .font_6 {
        font-size: 18px;
        font-family: PingFang;
        line-height: 17px;
        color: #333333;
      }
      .group_5 {
        padding-top: 150px;
        height: 203px;
        .pos_13 {
          position: absolute;
          left: 285px;
          top: 150px;
        }
        .pos_9 {
          position: absolute;
          left: 0;
          top: 100px;
        }
        .pos_10 {
          position: absolute;
          left: 285px;
          top: 100px;
        }
        .pos_5 {
          position: absolute;
          left: 0;
          top: 49px;
        }
        .pos_6 {
          position: absolute;
          left: 285px;
          top: 49px;
        }
        .pos {
          position: absolute;
          left: 0;
          top: 0;
        }
        .pos_2 {
          position: absolute;
          left: 285px;
          top: 0;
        }
        .pos_14 {
          position: absolute;
          right: 358px;
          top: 150px;
        }
        .pos_15 {
          position: absolute;
          right: 0;
          top: 150px;
        }
        .pos_11 {
          position: absolute;
          right: 358px;
          top: 99px;
        }
        .pos_12 {
          position: absolute;
          right: 0;
          top: 100px;
        }
        .pos_7 {
          position: absolute;
          right: 358px;
          top: 50px;
        }
        .pos_8 {
          position: absolute;
          right: 0;
          top: 49px;
        }
        .pos_3 {
          position: absolute;
          right: 358px;
          top: 0;
        }
        .pos_4 {
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .group_6 {
        padding-top: 51px;
        .pos_20 {
          position: absolute;
          left: 285px;
          top: 51px;
        }
        .pos_16 {
          position: absolute;
          left: 0;
          top: 0;
        }
        .pos_17 {
          position: absolute;
          left: 285px;
          top: 0;
        }
        .pos_21 {
          position: absolute;
          right: 358px;
          top: 51px;
        }
        .pos_22 {
          position: absolute;
          right: 0;
          top: 51px;
        }
        .pos_18 {
          position: absolute;
          right: 358px;
          top: 0;
        }
        .pos_19 {
          position: absolute;
          right: 0;
          top: 0;
        }
        .text-wrapper_10 {
          padding: 23px 0;
          background-color: #ffffff;
          width: 1004px;
          height: 52px;
          border-left: solid 1px #9ac8f1;
          border-right: solid 1px #9ac8f1;
          border-top: solid 1px #9ac8f1;
          border-bottom: solid 1px #9ac8f1;
          .text_46 {
            margin-left: 12px;
          }
        }
        .pos_38 {
          position: absolute;
          right: 0;
          top: 51px;
        }
        .pos_36 {
          position: absolute;
          right: 358px;
          top: 0;
        }
        .pos_34 {
          position: absolute;
          left: 0;
          top: 0;
        }
        .pos_35 {
          position: absolute;
          left: 285px;
          top: 0;
        }
        .pos_37 {
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .text-wrapper_3 {
        padding: 16px 0;
        background-color: #e8f0fa;
        width: 287px;
        height: 53px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_13 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_25 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_22 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_19 {
          margin-left: 10px;
        }
        .text_15 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_30 {
          line-height: 18px;
        }
        .text_32 {
          line-height: 18px;
        }
        .text_37 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_38 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_45 {
          margin-left: 10px;
        }
        .text_43 {
          margin-left: 10px;
          line-height: 18px;
        }
        .text_42 {
          margin-left: 10px;
          line-height: 18px;
        }
      }
      .text_9 {
        margin-left: 10px;
      }
      .text-wrapper_4 {
        padding: 16px 0;
        background-color: #ffffff;
        width: 360px;
        height: 53px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_14 {
          line-height: 18px;
        }
        .text_16 {
          margin-left: 13px;
          line-height: 18px;
        }
        .text_31 {
          line-height: 18px;
        }
        .text_33 {
          margin-left: 13px;
        }
      }
      .text-wrapper_5 {
        padding: 17px 0;
        background-color: #e8f0fa;
        width: 287px;
        height: 53px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_17 {
          margin-left: 10px;
        }
        .text_28 {
          margin-left: 10px;
        }
        .text_39 {
          margin-left: 10px;
        }
        .text_35 {
          margin-left: 10px;
        }
        .text_36 {
          margin-left: 10px;
        }
      }
      .text_11 {
        margin-left: 10px;
      }
      .text-wrapper_6 {
        padding: 17px 0;
        background-color: #ffffff;
        width: 360px;
        height: 53px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_18 {
          margin-left: 13px;
        }
        .text_26 {
          margin-left: 13px;
          color: #006ed1;
        }
        .text_29 {
          margin-left: 14px;
        }
        .text_40 {
          margin-left: 13px;
        }
      }
      .text_12 {
        margin-left: 14px;
      }
      .text-wrapper_9 {
        padding: 41px 0 34px;
        background-color: #e8f0fa;
        width: 287px;
        height: 95px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_34 {
          line-height: 18px;
        }
      }
      .text_24 {
        margin-left: 10px;
      }
      .section_3 {
        padding: 12px 0;
        background-color: #ffffff;
        width: 360px;
        height: 95px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .group_7 {
          margin-left: 12px;
          line-height: 22px;
        }
      }
      .text_21 {
        margin-left: 10px;
        line-height: 18px;
      }
      .section_4 {
        padding: 14px 0;
        background-color: #ffffff;
        width: 360px;
        height: 95px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .group_8 {
          margin-left: 12px;
          line-height: 22px;
        }
      }
      .font_9 {
        font-size: 18px;
        font-family: PingFang;
        line-height: 22px;
        color: #333333;
      }
      .group_9 {
        padding-top: 100px;
        .pos_31 {
          position: absolute;
          left: 285px;
          top: 100px;
        }
        .pos_27 {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .pos_28 {
          position: absolute;
          left: 285px;
          top: 50%;
          transform: translateY(-50%);
        }
        .pos_23 {
          position: absolute;
          left: 0;
          top: 0;
        }
        .pos_24 {
          position: absolute;
          left: 285px;
          top: 0;
        }
        .pos_32 {
          position: absolute;
          right: 358px;
          top: 100px;
        }
        .pos_33 {
          position: absolute;
          right: 0;
          top: 100px;
        }
        .pos_29 {
          position: absolute;
          right: 358px;
          top: 50%;
          transform: translateY(-50%);
        }
        .pos_30 {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        .pos_25 {
          position: absolute;
          right: 358px;
          top: 0;
        }
        .pos_26 {
          position: absolute;
          right: 0;
          top: 0;
        }
      }
      .text-wrapper_7 {
        padding: 18px 0;
        background-color: #ffffff;
        width: 360px;
        height: 53px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .font_7 {
          font-size: 18px;
          font-family: PingFang;
          line-height: 14px;
          color: #333333;
        }
        .text_20 {
          margin-left: 13px;
        }
      }
      .text-wrapper_8 {
        padding: 24px 0;
        background-color: #ffffff;
        width: 360px;
        height: 53px;
        border-left: solid 1px #9ac8f1;
        border-right: solid 1px #9ac8f1;
        border-top: solid 1px #9ac8f1;
        border-bottom: solid 1px #9ac8f1;
        .text_23 {
          margin-left: 13px;
          line-height: 3px;
        }
        .text_41 {
          margin-left: 12px;
        }
        .text_44 {
          margin-left: 12px;
        }
      }
      .font_8 {
        font-size: 18px;
        font-family: PingFang;
        line-height: 4px;
        color: #333333;
      }
    }
    .view {
      margin-top: 21px;
    }
    .text_27 {
      margin-left: 89px;
      margin-top: 38px;
    }
    .view_2 {
      margin-top: 20px;
    }
  }
</style>
